import { get, post } from "../request-manager";

export function getAppManagementList(): Promise<AppManagementType.AppManagementListRes> {
  return get(`/v1alpha1/clients`, { params: { page: 1, pageSize: 100 } });
}

export function CreateAppManagement(params: AppManagementType.CreateAppManagementParam): Promise<AppManagementType.CreateAppManagementRes> {
  return post(`/v1alpha1/clients`, params);
}

export function deleteAppManagement(params: any) {
  return post(`/v1alpha1/clients/delete`, params);
}
